import { cn } from "@/lib/utils";

/** The assistant's mark: the Steddy star, decorative (the surface around it carries the name). */
export function AssistantMark({ className }: { className?: string }) {
  return (
    <img
      src="/steddy-star.svg"
      alt=""
      aria-hidden="true"
      className={cn("h-4 w-4 shrink-0", className)}
    />
  );
}
